/* window.BotHelp: оболочка собрана компонентом, контракт PAGES тот же (init, mount, fill, after, reply). */
import { definePageModule } from '../../bridge/page-module';
import { Help } from './Help';
import { createHelp } from './engine';
import { isServerMode } from '../../platform/server-mode';
import { helpServer } from './help-server';

const SKIP = new Set(['markup', 'prepare', 'attach', 'init', 'unmount', 'S', 'fill', 'after', 'PREFIX', 'TESTS', 'mounted']);

export interface HelpView {
  body: string;
}

export interface HelpApi {
  prepare: () => HelpView;
  attach: () => void;
  init: (o: BotPageUi) => void;
  unmount: () => void;
  fill: (...args: unknown[]) => void;
  after: () => void;
  S: object;
  PREFIX: string;
  TESTS: [string, [string, string][]][];
}

let api: HelpApi;

/** Экран берёт api при отрисовке: installHelp уже вызван */
export function helpApi() {
  return api;
}

/** Методы и геттеры раздела, кроме тех, что забирает контракт страницы */
function liveExtras(b: object): Record<string, unknown> {
  const extra: Record<string, unknown> = {};
  for (const [k, d] of Object.entries(Object.getOwnPropertyDescriptors(b))) {
    if (SKIP.has(k)) continue;
    if (d.get) Object.defineProperty(extra, k, { enumerable: true, get: () => (b as Record<string, unknown>)[k] });
    else if (typeof d.value === 'function') {
      const fn = d.value as (...args: unknown[]) => unknown;
      extra[k] = (...args: unknown[]) => fn.apply(b, args);
    } else extra[k] = d.value;
  }
  return extra;
}

export function installHelp() {
  const server = isServerMode();
  const b = createHelp() as unknown as HelpApi;
  if (server) b.init({ server: helpServer } as unknown as BotPageUi);
  api = b;
  definePageModule({
    global: 'BotHelp',
    PREFIX: b.PREFIX,
    TESTS: server ? [] : b.TESTS,
    S: b.S,
    Page: Help,
    init(o) {
      b.init(o);
    },
    fill(...args: unknown[]) {
      if (!server) b.fill(...args);
    },
    after() {
      b.after();
    },
    beforeUnmount() {
      b.unmount();
    },
    extra: liveExtras(b),
  });
}
